import { c as _c } from "react/compiler-runtime";
import BaseLink from "@/components/common/base-link/base-link";
import { slugify } from "@/utilities/slugify";
type Props = {
  name: string;
  id: string;
  className?: string;
  children?: React.ReactNode;
};
const SlugifiedAuthorLink = t0 => {
  const $ = _c(10);
  const {
    name,
    id,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = slugify(name);
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  let t2;
  if ($[2] !== id || $[3] !== slug) {
    t2 = {
      pathname: "/learn/author/[slug]",
      query: {
        slug,
        id
      }
    };
    $[2] = id;
    $[3] = slug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `/learn/author/${slug}`;
  const t4 = children ?? name;
  let t5;
  if ($[5] !== className || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <BaseLink className={className} href={t2} as={t3}>{t4}</BaseLink>;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default SlugifiedAuthorLink;